"use client"

import type React from "react"

import { motion } from "framer-motion"

interface ContentSectionProps {
  title: string
  children: React.ReactNode
  className?: string
  backgroundColor?: string
}

export const ContentSection = ({
  title,
  children,
  className = "",
  backgroundColor = "bg-white",
}: ContentSectionProps) => {
  return (
    <section className={`py-16 md:py-20 ${backgroundColor}`}>
      <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-12 text-center md:mb-16"
        >
          <h2 className="mb-4 text-2xl font-bold text-slate-900 sm:text-3xl md:mb-6 md:text-4xl lg:text-5xl">
            {title}
          </h2>
        </motion.div>
        {children}
      </div>
    </section>
  )
}

export default ContentSection
